import React, { useState, useEffect, useRef } from "react";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import Doc from "../../assets/assets/docpos.svg";
import { useHistory } from "react-router-dom";
import { PropTypes } from "prop-types";
import { useDispatch } from "react-redux";
import { resetSubmitAgreementStatus } from "../../redux/Actions/TestCasesActions";
const Certificate = ({
  trail,
  viewCert,
  openModal,
  isSubmitting,
  submitAgreement, 
  userType,
  submitSuccess,
  getUserTrail,
}) => {
  const [hasHandledSubmit, setHasHandledSubmit] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
 

  const [state, setState] = useState({
    checkedOptionState: false,
  });
  const [hasSubmitted, setHasSubmitted] = useState(false);

  // Restore checkbox state from localStorage
  useEffect(() => {
    const savedState = localStorage.getItem("checkedOptionState");
    if (savedState === "true") {
      setState({ checkedOptionState: true });
    }
  }, []);

useEffect(() => {
  if (
    state.checkedOptionState &&
    submitSuccess &&
    !hasHandledSubmit
  ) {
    setHasHandledSubmit(true);
    getUserTrail();
    localStorage.removeItem("checkedOptionState");
    dispatch(resetSubmitAgreementStatus());
  }
}, [getUserTrail, dispatch]);


  const goToDeviceRenew = (id) => {
    history.push({
      pathname: "/device/renewal/details",
      state: { id },
    });
  };

  const goToAppRenew = (id) => {
    history.push({
      pathname: "/application/renewal/details",
      state: { id },
    });
  };


const updateState = async (appId) => {
  if (hasSubmitted) return;
  setHasSubmitted(true);

  const payload = {
    application_id: appId,
  };

  try {
    console.log("Submitting agreement...");
    await submitAgreement(payload);
    console.log("Submitted successfully");
  } catch (err) {
    console.error("Submit agreement crashed:", err);
  }
};


const handleCheckboxChange = (e) => {
  e.preventDefault(); 
  e.stopPropagation(); 

  const isChecked = e.target.checked;
  setState({ checkedOptionState: isChecked });
  localStorage.setItem("checkedOptionState", isChecked);

  if (isChecked && !hasSubmitted) {
    setHasSubmitted(true);
    updateState(trail.id);
  }
};



  const renderTermsCheckbox = () => (
    <div className="doc-terms">
      <input
        id="terms-box"
        type="checkbox"
        checked={state.checkedOptionState}
        disabled={hasSubmitted}
        onChange={handleCheckboxChange}
      />
      <label htmlFor="terms-box" className="checkbox-custom-label"></label>
      <span>
        By clicking on the download link, you accept NIBSS{" "}
        <small onClick={openModal}>Terms and <br /> Conditions</small>
      </span>
    </div>
  );

  return trail &&
    trail.certificate_url &&
    trail.trail?.admin?.certificateAssigned ? (
    <div className="bottom">
      {trail.certificate_terms_and_agreement === true && (
        <div className="bottom-progress">
          <div className="bottom-progress-left">
            <p>
              Your POS{" "}
              {trail.application_type === "pos_device_certification"
                ? "Device"
                : "Application"}{" "}
              certification available for use
            </p>
            <div className="progress-bar">
              <CircularProgressbarWithChildren
                value={trail.cert_days_left}
                strokeWidth={4}
                styles={buildStyles({
                  rotation: 0.25,
                  strokeLinecap: "butt",
                  textSize: "14px",
                  pathTransitionDuration: 0.5,
                  pathColor:
                    trail.cert_days_left <= 10 ? "red" : "lightgreen",
                  textColor: "#808080",
                  trailColor: "#d6d6d6",
                  backgroundColor: "#3e98c7",
                })}
              >
                <div className="text-div">
                  <div className="text-bar1">{trail.cert_days_left}</div>
                  <div className="text-bar2">Days Left</div>
                </div>
              </CircularProgressbarWithChildren>
            </div>
          </div>

          {userType !== "staff" && (
            <div>
              <button
                className="button1"
                onClick={() =>
                  trail.application_type === "pos_device_certification"
                    ? goToDeviceRenew(trail.id)
                    : goToAppRenew(trail.id)
                }
              >
                Renew
              </button>
            </div>
          )}

          <div className="doc-btn">
            <button onClick={viewCert}>
              <img src={Doc} alt="doc-icon" />
              VIEW CERTIFICATION
            </button>
          </div>
        </div>
      )}

      {trail.certificate_terms_and_agreement !== true &&
        userType !== "staff" && (
          <div className="bottom-terms">
            <p>
              Your POS{" "}
              {trail.application_type === "pos_device_certification"
                ? "Device"
                : "Application"}{" "}
              certification is ready.
            </p>
            <div className="left">
              {isSubmitting ? (
                <div className="doc-terms">
                  <h3>Accepting terms and conditions.....</h3>
                </div>
              ) : (
                <>
                  {renderTermsCheckbox()}
                  <div className="doc-btn">
                    <button
                      disabled={
                        !state.checkedOptionState || isSubmitting
                      }
                      onClick={viewCert}
                    >
                      <img src={Doc} alt="doc-icon" />
                      VIEW CERTIFICATION
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
    </div>
  ) : (
    <div></div>
  );
};

Certificate.propTypes = {
  trail: PropTypes.object,
  viewCert: PropTypes.func,
  openModal: PropTypes.func,
  isSubmitting: PropTypes.bool,
  submitAgreement: PropTypes.func,
  userType: PropTypes.string,
  submitSuccess: PropTypes.bool,
  getUserTrail: PropTypes.func,
};

export default Certificate;




